/**
 * Join label segments (e.g. type, colour, size) with a separator, skipping any
 * that are empty / nullish so a SKU missing size or colour never renders with
 * dangling separators like "TEE ·  · " or a leading " - M". (BLU-296)
 *
 * @example joinParts(['TEE', null, 'M'])          // "TEE · M"
 * @example joinParts(['TEE', null, null], ' - ')  // "TEE"
 * @example joinParts([null, null, 'M'], ' - ')    // "M"
 */
export function joinParts(
  parts: Array<string | null | undefined>,
  separator = ' · ',
): string {
  return parts
    .map((part) => (typeof part === 'string' ? part.trim() : part))
    .filter((part): part is string => Boolean(part))
    .join(separator);
}
